class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.button = this.form?.querySelector('button[type="submit"]');
    this.spinner = this.button?.querySelector('.loading-overlay__spinner');
    this.pendingAdd = false;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.startLoading();
      this.addToCart();
    });

    document.addEventListener('cart:refresh:done', () => {
      if (this.pendingAdd) this.stopLoading();
    });
  }

  async addToCart() {
    const formData = new FormData(this.form);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!res.ok) {
      console.error('Add to cart failed');
      this.stopLoading();
      return;
    }

    this.pendingAdd = true;
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    if (this.form.dataset.openCart == 'true') {
      document.querySelector('cart-drawer').open();
    }
  }

  startLoading() {
    if (!this.button) return;
    this.pendingAdd = false;
    this.button.disabled = true;
    this.button.classList.add('is-loading');
    this.spinner?.classList.remove('hidden');
  }

  stopLoading() {
    if (!this.button) return;
    this.pendingAdd = false;
    this.button.disabled = false;
    this.button.classList.remove('is-loading');
    this.spinner?.classList.add('hidden');
  }
}

customElements.define('product-form', ProductForm);
